import store from "../../../../store";
import { BANK_MASTER, EXPLORE_CLIENT_NAME_FILTERS, EXPLORE_INVESTMENT_VALUE_FILTERS, EXPLORE_ORDER_BOOK_CANCEL_ORDER, EXPLORE_ORDER_BOOK_CLIENT_PAN, EXPLORE_ORDER_BOOK_DOWNLOAD_DATA, EXPLORE_ORDER_BOOK_DUPLICATE_ORDER, EXPLORE_PRODUCT_TYPES_FILTERS, EXPLORE_STATUS_FILTERS, ORDER_BOOK_DETAILS_REQUEST_PAYLOAD, ORDER_BOOK_FILTER_REQUEST_PAYLOAD, ORDER_BOOK_RESEND_CONSENT_REQUEST_PAYLOAD, ORDER_BOOK_TABLE_NCD_REQUEST_PAYLOAD, ORDER_BOOK_TABLE_NCD_SCHEMES, ORDER_BOOK_TABLE_REQUEST_PAYLOAD, ORDER_BOOK_TABLE_SCHEMES, ORDER_BOOK_TIME_LINE, SET_SUSPENSE_FORM, UPDATE_IS_REFUND_REASON_SELECTED, UPDATE_MODIFY_PAYMENT_MODE, UPDATE_MODIFY_PAYMENT_MODE_DOC, UPDATE_PREVIEW_SUSPENSE_DOCS, UPDATE_REFUND, UPDATE_REFUND_NCD_TYPE, UPDATE_REFUND_TYPE, UPDATE_SELECTED_REFUND_REASON, UPDATE_SELECTED_REFUND_TYPE, UPDATE_SUSPENSE_REFUND, UPDATE_UPLOAD_SUSPENSE_DOCS, UPDATE_VALIDATE_INTEREST, UPDATE_VALIDATE_UTR, } from "../interface/IOrderbook";
var OrderBookActions = /** @class */ (function () {
    function OrderBookActions() {
        this.dispatch = store.dispatch;
    }
    OrderBookActions.prototype.updateModifyPaymentModeDoc = function (req) {
        this.dispatch({
            type: UPDATE_MODIFY_PAYMENT_MODE_DOC,
            payload: { modifyPaymentModeDoc: req },
        });
    };
    OrderBookActions.prototype.updateModifyPaymentMode = function (req) {
        this.dispatch({
            type: UPDATE_MODIFY_PAYMENT_MODE,
            payload: { modifyPaymentMode: req },
        });
    };
    OrderBookActions.prototype.getClientPan = function (req) {
        this.dispatch({
            type: EXPLORE_ORDER_BOOK_CLIENT_PAN,
            payload: { clientPanData: req },
        });
    };
    OrderBookActions.prototype.cancelOrder = function (req) {
        this.dispatch({
            type: EXPLORE_ORDER_BOOK_CANCEL_ORDER,
            payload: { cancelOrder: req },
        });
    };
    OrderBookActions.prototype.duplicateOrder = function (req) {
        this.dispatch({
            type: EXPLORE_ORDER_BOOK_DUPLICATE_ORDER,
            payload: { duplicateOrder: req },
        });
    };
    OrderBookActions.prototype.getOrderBookDownloadData = function (req) {
        this.dispatch({
            type: EXPLORE_ORDER_BOOK_DOWNLOAD_DATA,
            payload: { orderBookDownloadData: req },
        });
    };
    OrderBookActions.prototype.updateRefundNcdType = function (req) {
        this.dispatch({
            type: UPDATE_REFUND_NCD_TYPE,
            payload: { refundNcdType: req },
        });
    };
    OrderBookActions.prototype.uploadSuspenseDoc = function (req) {
        this.dispatch({
            type: UPDATE_UPLOAD_SUSPENSE_DOCS,
            payload: { uploadSuspenseDoc: req },
        });
    };
    OrderBookActions.prototype.getBankMaster = function (bankMaster) {
        this.dispatch({
            type: BANK_MASTER,
            payload: { bankMaster: bankMaster },
        });
    };
    OrderBookActions.prototype.updateRefundType = function (req) {
        this.dispatch({
            type: UPDATE_REFUND_TYPE,
            payload: { refundType: req },
        });
    };
    OrderBookActions.prototype.updateSelectedRefundType = function (req) {
        this.dispatch({
            type: UPDATE_SELECTED_REFUND_TYPE,
            payload: { selectedRefundType: req },
        });
    };
    OrderBookActions.prototype.updateIsRefundReasonSelected = function (req) {
        this.dispatch({
            type: UPDATE_IS_REFUND_REASON_SELECTED,
            payload: {
                isRefundReasonSelected: req,
            },
        });
    };
    OrderBookActions.prototype.updateSelectedRefundReason = function (req) {
        this.dispatch({
            type: UPDATE_SELECTED_REFUND_REASON,
            payload: {
                selectedRefundReason: req,
            },
        });
    };
    OrderBookActions.prototype.validateInterest = function (req) {
        this.dispatch({
            type: UPDATE_VALIDATE_INTEREST,
            payload: { validateInterest: req },
        });
    };
    OrderBookActions.prototype.validateUtr = function (req) {
        this.dispatch({
            type: UPDATE_VALIDATE_UTR,
            payload: { validateUtr: req },
        });
    };
    OrderBookActions.prototype.suspenseRefund = function (req) {
        this.dispatch({
            type: UPDATE_SUSPENSE_REFUND,
            payload: { suspenseRefund: req },
        });
    };
    OrderBookActions.prototype.refund = function (req) {
        this.dispatch({
            type: UPDATE_REFUND,
            payload: { refund: req },
        });
    };
    OrderBookActions.prototype.previewSuspenseDoc = function (req) {
        this.dispatch({
            type: UPDATE_PREVIEW_SUSPENSE_DOCS,
            payload: { previewSuspenseDoc: req },
        });
    };
    OrderBookActions.prototype.getOrderBookTimeline = function (orderBookTimeline) {
        this.dispatch({
            type: ORDER_BOOK_TIME_LINE,
            payload: { orderBookTimeline: orderBookTimeline },
        });
    };
    OrderBookActions.prototype.getOrderBookNcdTable = function (orderBookNcdTable) {
        this.dispatch({
            type: ORDER_BOOK_TABLE_NCD_SCHEMES,
            payload: { orderBookNcdTable: orderBookNcdTable },
        });
    };
    OrderBookActions.prototype.getOrderBookDetails = function (orderBookDetails) {
        this.dispatch({
            type: ORDER_BOOK_DETAILS_REQUEST_PAYLOAD,
            payload: { orderBookDetails: orderBookDetails },
        });
    };
    OrderBookActions.prototype.getOrderBookFilter = function (orderBookFilter) {
        this.dispatch({
            type: ORDER_BOOK_FILTER_REQUEST_PAYLOAD,
            payload: { orderBookFilter: orderBookFilter },
        });
    };
    OrderBookActions.prototype.getOrderBookResendConsent = function (orderBookResendConsent) {
        this.dispatch({
            type: ORDER_BOOK_RESEND_CONSENT_REQUEST_PAYLOAD,
            payload: { orderBookResendConsent: orderBookResendConsent },
        });
    };
    OrderBookActions.prototype.setOrderBookRequestPayload = function (orderBookRequestPayload) {
        this.dispatch({
            type: ORDER_BOOK_TABLE_REQUEST_PAYLOAD,
            payload: { orderBookRequestPayload: orderBookRequestPayload },
        });
    };
    OrderBookActions.prototype.setOrderBookNcdRequestPayload = function (orderBookNcdRequestPayload) {
        this.dispatch({
            type: ORDER_BOOK_TABLE_NCD_REQUEST_PAYLOAD,
            payload: { orderBookNcdRequestPayload: orderBookNcdRequestPayload },
        });
    };
    OrderBookActions.prototype.getOrderBookTable = function (orderBookTable) {
        this.dispatch({
            type: ORDER_BOOK_TABLE_SCHEMES,
            payload: { orderBookTable: orderBookTable },
        });
    };
    OrderBookActions.prototype.setSuspenseForm = function (suspenseFormData) {
        this.dispatch({
            type: SET_SUSPENSE_FORM,
            payload: { suspenseFormData: suspenseFormData },
        });
    };
    OrderBookActions.prototype.getProductTypesFilters = function (productProductTypesFilters) {
        this.dispatch({
            type: EXPLORE_PRODUCT_TYPES_FILTERS,
            payload: { productProductTypesFilters: productProductTypesFilters },
        });
    };
    OrderBookActions.prototype.getStatusFilters = function (productStatusFilters) {
        this.dispatch({
            type: EXPLORE_STATUS_FILTERS,
            payload: { productStatusFilters: productStatusFilters },
        });
    };
    OrderBookActions.prototype.getClientNameFilters = function (productClientNameFilters) {
        this.dispatch({
            type: EXPLORE_CLIENT_NAME_FILTERS,
            payload: { productClientNameFilters: productClientNameFilters },
        });
    };
    OrderBookActions.prototype.getInvestmentValueFilters = function (productInvestmentValueFilters) {
        this.dispatch({
            type: EXPLORE_INVESTMENT_VALUE_FILTERS,
            payload: { productInvestmentValueFilters: productInvestmentValueFilters },
        });
    };
    OrderBookActions.prototype.setError = function (payload, errorType) { };
    OrderBookActions.prototype.hideError = function (errorType) { };
    return OrderBookActions;
}());
export default OrderBookActions;
